import { render, staticRenderFns } from "./ThemeLogo.view.vue?vue&type=template&id=64e9be20&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64e9be20')) {
      api.createRecord('64e9be20', component.options)
    } else {
      api.reload('64e9be20', component.options)
    }
    module.hot.accept("./ThemeLogo.view.vue?vue&type=template&id=64e9be20&", function () {
      api.rerender('64e9be20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/layouts/logo/ThemeLogo.view.vue"
export default component.exports